import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchResignationNoticesApi } from "./resignationsApi";

export const fetchResignationNotices = createAsyncThunk(
  "resignations/fetchNotices",
  async ({ page, size, filters }, { rejectWithValue }) => {
    try {
      const data = await fetchResignationNoticesApi(page, size, filters);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.ExceptionMessage || error.response.data.message || "İstifa bildirimleri alınamadı.");
      }
      return rejectWithValue("İstifa bildirimleri alınırken bağlantı hatası oluştu.");
    }
  }
);
